<template>
  <div class="field-group">
    <label class="field-label-compact">
      Fecha de nacimiento<span class="required-asterisk">*</span>
    </label>
    <!-- el-date-picker renders an ElTooltip root that drops the scope id, so scoped styles target this wrapper. -->
    <div class="field-date-picker-compact field-input-compact" :class="{ 'field-error': isUnderage }">
      <el-date-picker
        :model-value="birthDate"
        type="date"
        placeholder="Selecciona tu fecha"
        format="DD/MM/YYYY"
        value-format="YYYY-MM-DD"
        size="large"
        teleported
        popper-class="widget-datepicker-dropdown"
        :popper-options="selectPopperOptions"
        @update:model-value="emit('update:birthDate', $event)"
      />
    </div>
    <span v-if="isUnderage" class="field-error-message">
      Debes ser mayor de edad (18 años)
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useFormValidation } from '@/composables/useFormValidation';
import { selectPopperOptions } from './selectPopperOptions';

const props = defineProps<{ birthDate: string }>();

const emit = defineEmits<{ 'update:birthDate': [value: unknown] }>();

const { isAdult } = useFormValidation();

const isUnderage = computed(() => Boolean(props.birthDate) && !isAdult(props.birthDate));
</script>

<style scoped src="./fields.css"></style>
<style scoped src="./inputs.css"></style>
